/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 15:27:01                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-05 15:45:41                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * SuperAdmin: Super admin view
*/

/* Imports */
import { Outlet } from "react-router-dom";
import AdminNavLayout from "./layouts/AdminNavLayout";
/***/

/**
* SuperAdmin: Super admin view 
*/
export default function SuperAdmin() {
  return (
    <div>
      <AdminNavLayout>
        <Outlet/>
      </AdminNavLayout>
    </div>
  );
}
/***/
